module.exports = __webpack_public_path__ + "img/prevent-1-pic.afc9b137.jpg";